import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { EHealthDmgMessages, EHealthService } from 'src/app/services/e-health.service';

@ManageType('EHealthDmgListDialogComponent')
@Component({
  selector: 'app-e-health-dmg-list-dialog',
  templateUrl: './e-health-dmg-list-dialog.component.html',
  styleUrls: ['./e-health-dmg-list-dialog.component.scss']
})
export class EHealthDmgListDialogComponent implements OnInit {

  private tackValue;
  public messages: EHealthDmgMessages;
  public columnsIo = ['io', 'actions'];
  public columnsMessage = ['lastname', 'firstname', 'from', 'to'];
  public ioDisplay: Map<string, boolean> = new Map();
  public dmgDate: Date;
  public dmgOA: string;

  constructor(private ehealth: EHealthService) { }

  ngOnInit(): void {
  }

  requestDMG(): void {
    const dmgsubs = this.ehealth.userdmglist(this.dmgDate, this.dmgOA).subscribe(result => {
      this.tackValue = result.result.tack;
      console.log('tack', this.tackValue);
      dmgsubs.unsubscribe();
    });
  }

  getMsg(): void {
    const dmgsubs = this.ehealth.dmgmessages([]).subscribe(messages => {
      dmgsubs.unsubscribe();
      if (messages.lists) {
        this.ioDisplay = new Map();
        messages.lists.forEach(list => {
          this.ioDisplay.set(list.list.reference, false);
        });
      }
      this.messages = messages;
    });
  }

  confirm(msgHash: string) {
    const dmgsubs = this.ehealth.confirmdmgmessages([msgHash]).subscribe(result => {
      console.log('confirm result', result);
      dmgsubs.unsubscribe();
    });
  }
}
